// extracted by css-extract-rspack-plugin
export default {"root":"Yt5cO"};